import cs from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiFiles } from 'react-icons/pi';
import './FileDroppableArea.scss';

interface IFileDroppableAreaProps {
  visible?: boolean;
}

const FileDroppableArea = ({ visible }: IFileDroppableAreaProps) => {
  const { t } = useTranslation();
  const classNames = cs(['file-droppable-area'], { visible });

  return (
    <div className={classNames}>
      <div className='file-droppable-area-content'>
        <PiFiles />
        <h1>{t('dropzone.header')}</h1>
        <p>{t('dropzone.description')}</p>
      </div>
    </div>
  );
};

export default FileDroppableArea;
